import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=8778bdcc&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=8778bdcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8778bdcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8778bdcc')) {
      api.createRecord('8778bdcc', component.options)
    } else {
      api.reload('8778bdcc', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=8778bdcc&scoped=true&", function () {
      api.rerender('8778bdcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2a7wQ6dhbMo6h/JS/comp/GuestBox.vue"
export default component.exports